export default {
  preValidationNfe: {
    configuracao: false,
    emissor: false,
  },
};
